import { defineStore } from "pinia";
import { ref } from "vue";

export const useEnvironmentStore = defineStore("environment", () => {
    const api = ref<string>();
    const assets = ref<string>();
    const zh = ref<string>();

    function inject(apiEndpoint: string, assetsEndpoint: string, zhEndpoint: string) {
        api.value = apiEndpoint;
        assets.value = assetsEndpoint;
        zh.value = zhEndpoint;
    }

    return { api, assets, zh, inject };
});
